module.exports = __webpack_public_path__ + "img/pick3.ebb23b57.png";